<template>
    <div class="sidebar-wrapper"
        :class="{ 'sidebar-wrapper-open': (isSidebarOpen && !floatingNav), 'sidebar-wrapper-close': (!isSidebarOpen && !floatingNav), 'floating-sidebar-open': (isSidebarOpen && floatingNav), 'floating-sidebar-close': (!isSidebarOpen && floatingNav) }">
        <div class="d-flex justify-content-center pt-3 pb-4 ml-2 lg:ml-4 mb-2 mt-2 position-relative">
            <div class="brandLogo">
                <img v-show="isSidebarOpen" src="img/brand/brand_logos/SVG/sense_logo.svg" height="52"
                    alt="Brand Logo Full" />
                <img v-show="!isSidebarOpen && !floatingNav" src="img/brand/brand_logos/SVG/weavr_logo.svg" height="32"
                    alt="Brand Logo Minimized" />
            </div>
            <div class="d-flex justify-content-center align-items-center position-absolute"
                :class="isSidebarOpen ? 'toggler-open' : 'toggler-close'" @click="toggleSidebar">
                <img v-show="isSidebarOpen" src="Icons_SVG/Sidebar Toggle Left.svg" alt="left-toggler" />
                <img v-show="!isSidebarOpen && !floatingNav" src="Icons_SVG/Sidebar Toggle Right.svg"
                    alt="right-toggler" />
            </div>
        </div>
        <div @mouseenter="$emit('open-sidebar');" @mouseleave="$emit('close-sidebar');" class="py-2"
            :class="{ 'd-flex flex-column align-tems-center': !isSidebarOpen }">
            <div v-for="(menuItem, menuIndex) in menuItems" :key="menuItem.name"
                v-if="(floatingNav && isSidebarOpen) || !floatingNav" @click="setIndex(menuIndex, menuItem)" :class="{
                    'active-router': currentTab == menuIndex && (!menuItem.submenuItems || !isSidebarOpen),
                    'menu-list': !menuItem.submenuItems,
                }">
                <div v-if="!menuItem.submenuItems" class="d-flex align-items-center" :class="{
                    'flex-column justify-content-center align-items-between': !isSidebarOpen,
                    'flex-row align-items-center': isSidebarOpen
                }">
                    <img :src="require(`../../public/Icons_SVG/${menuItem.name}.svg`)" :alt="menuItem.name + '_icon'"
                        class="sidebar-icons" />
                    <router-link :to="menuItem.url">
                        <div style="text-align: center;" :style="isSidebarOpen ? 'font-size: 16px' : 'font-size: 10px'">{{ menuItem.name }}</div>
                    </router-link>
                </div>
                <div v-else>
                    <div class="d-flex" :class="{
                        'flex-column justify-content-center align-items-between': !isSidebarOpen,
                        'flex-row align-items-center': isSidebarOpen
                    }">
                        <img :src="require(`../../public/Icons_SVG/${menuItem.name}.svg`)"
                            :alt="menuItem.name + '_icon'" class="sidebar-icons" />
                        <span
                            style="color: white; cursor: default; text-align: center;" :style="isSidebarOpen ? 'font-size: 16px' : 'font-size: 10px'">{{
                                menuItem.name }}</span>
                    </div>
                    <div v-show="isSidebarOpen" v-for="(submenu, submenuIndex) in menuItem.submenuItems"
                        :key="submenu.name" @click="setSubmenuIndex(menuIndex, submenu, submenuIndex)" class="menu-list"
                        style="margin-left: 4rem; padding-block: 6px; padding-left: 1rem;" :class="{
                            'active-router': currentTab == menuIndex && currentSubmenu == submenuIndex,
                        }">
                        <router-link :to="submenu.url">
                            <div v-show="isSidebarOpen">{{ submenu.name }}</div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showOverlay" class="pc-menu-overlay"></div>
    </div>
</template>

<script>
export default {
    name: "CustomSidebar",
    props: { menuItems: Array, isSidebarOpen: Boolean },
    data() {
        return {
            currentTab: localStorage.menuIndex,
            currentSubmenu: localStorage.submenuIndex,
            showOverlay: false
        };
    },

    created() {
        if (localStorage.getItem("reloaded")) {
            localStorage.removeItem("reloaded");
        } else {
            localStorage.setItem("reloaded", "1");
            location.reload();
        }
        if (localStorage.getItem("menuIndex")) {
            this.currentTab = localStorage.menuIndex;
            if (localStorage.getItem("submenuIndex")) {
                this.currentSubmenu = localStorage.submenuIndex
            }
        } else {
            localStorage.setItem("menuIndex", "0");
        }
    },
    computed: {
        floatingNav() {
            if (window.screen.width < 1024) {
                return true;
            } else return;
        },
    },
    mounted() {
        if (localStorage.menuIndex) {
            if (localStorage.submenuIndex) {
                this.setSubmenuIndex(localStorage.menuIndex, this.menuItems[localStorage.menuIndex].submenuItems[localStorage.submenuIndex], localStorage.submenuIndex);
            } else this.setIndex(localStorage.menuIndex, this.menuItems[localStorage.menuIndex]);
        } else {
            if (this.menuItems[0].submenuItems) {
                this.setSubmenuIndex(0, this.menuItems[0].submenuItems[0], 0);
            } else this.setIndex(0, this.menuItems[0]);
        }

        if (window.innerWidth <= 1033 && this.isSidebarOpen) {
            this.showOverlay = true;
        } else {
            this.showOverlay = false;
        }

    },
    methods: {
        setIndex(tabIndex, item) {
            this.currentTab = tabIndex;
            localStorage.setItem("menuIndex", tabIndex);
            if (!item.submenuItems && item.url !== this.$router.history.current.path) {
                this.$router.push(item.url);
            }
            if (window.innerWidth <= 1033 && this.isSidebarOpen) {
                this.toggleSidebar()
            }

        },
        setSubmenuIndex(menuIndex, item, submenuIndex) {
            this.currentTab = menuIndex;
            this.currentSubmenu = submenuIndex;
            localStorage.setItem("submenuIndex", submenuIndex);
            if (item.url !== this.$router.history.current.path) {
                this.$router.push(item.url);

            }

        },
        toggleSidebar() {
            this.$emit("toggle-sidebar", this.isSidebarOpen);

            if (window.innerWidth <= 1033) {
                console.log('dddddddddddd')
                this.showOverlay = !this.isSidebarOpen;
            } else {
                this.showOverlay = false;
            }
        },

    },
};
</script>

<style lang="scss" scoped>
.slide-enter-active {
    -moz-transition-duration: 0.17s;
    -webkit-transition-duration: 0.17s;
    -o-transition-duration: 0.17s;
    transition-duration: 0.17s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    -moz-transition-duration: 0s;
    -webkit-transition-duration: 0s;
    -o-transition-duration: 0s;
    transition-duration: 0s;
    -moz-transition-timing-function: ease-out;
    -webkit-transition-timing-function: ease-out;
    -o-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
}

.slide-enter-to,
.slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

.sidebar-wrapper {
    position: fixed !important;
    top: 0;
    height: 100vh !important;
    background: var(--primary_brand) !important;
    z-index: 1002 !important;
    transition: 0.5s;
    text-wrap: nowrap;
}

.floating-sidebar-open {
    width: 30%;
}

.floating-sidebar-close {
    width: 0;
}

.sidebar-icons {
    height: 25px;
    margin-block: 12px;
    margin-inline: 14px;
    padding-left: 9px;
    filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

.menu-items {
    margin-left: 36px;
}

.menu-list {
    position: relative;
    cursor: pointer;
}

.menu-list a {
    color: var(--white);
    text-decoration: none;
    cursor: pointer;
    font-size: 16px;
}

.menu-list:hover {
    color: var(--white) !important;
    background-color: var(--primary_brand-80);
    // border-radius: 1.7rem 0 0 1.7rem;
}

.active-router {
    color: var(--primary_brand) !important;
    background-color: var(--background);
    background-color: #f2f6f7;
    // border-radius: 1.7rem 0 0 1.7rem;
}

.active-router a {
    color: var(--primary_brand) !important;
}

.active-router img {
    height: 25px;
    margin-block: 12px;
    margin-inline: 14px;
    padding-left: 9px;
    filter: brightness(0) saturate(100%) invert(24%) sepia(10%) saturate(6256%) hue-rotate(144deg) brightness(97%) contrast(95%);
}

.active-router:hover {
    color: var(--primary_brand) !important;
    // background-color: var(--background);
    background-color: #f2f6f7;
    // border-radius: 1.7rem 0 0 1.7rem;
}

.toggler-open {
    position: relative;
    // left: 5%;
    right: -18px !important;
    cursor: pointer;
}

.toggler-open img {
    height: 30px;
}

.toggler-close {
    position: relative;
    right: -18px;
    cursor: pointer;
}

.toggler-close img {
    height: 30px;
}

@media (max-width: 1760px) {

    .menu-list>*,
    a,
    span {
        font-size: 14px !important;
    }

    .menu-items {
        margin-left: 20px;
    }
}

@media (max-width: 1550px) {

    .menu-list>*,
    a,
    span {
        font-size: 13px !important;
    }

    .menu-items {
        margin-left: 16px;
    }
}

@media (max-width: 1440px) {

    .menu-list>*,
    a,
    span {
        font-size: 13px !important;
    }

    .menu-items {
        margin-left: 10px;
    }
}

@media (min-width: 320px) and (max-width: 500px) {
    .floating-sidebar-open {
        width: 50%;
    }
}

@media (min-width: 500px) and (max-width: 640px) {
    .floating-sidebar-open {
        width: 40%;
    }
}

@media (min-width: 640px) and (max-width: 768px) {
    .floating-sidebar-open {
        width: 40%;
    }
}

@media (min-width: 768px) and (max-width: 830px) {
    .floating-sidebar-open {
        width: 35%;
    }
}



@media screen and (min-width: 1200px) {
    .sidebar-wrapper-open {
        width: 15% !important;
    }

    .sidebar-wrapper-close {
        width: 7% !important;
    }
}



@media screen and (min-width: 1500px) {
    .sidebar-wrapper-open {
        width: 15% !important;
    }

    .sidebar-wrapper-close {
        width: 6% !important;
    }
}

@media screen and (min-width: 2000px) {
    .sidebar-wrapper-open {
        width: 15% !important;
    }

    .sidebar-wrapper-close {
        width: 7% !important;
    }
}

// @media screen and (min-width: 2500px) {
//     .sidebar-wrapper-open {
//         width: 11% !important;
//     }

//     .sidebar-wrapper-close {
//         width: 7% !important;
//     }
// }












// ddd

// @media (min-width: 898px) and (max-width: 1033px) {
//     .sidebar-wrapper-open {
//         width: 18% !important;
//     }

//     .sidebar-wrapper-close {
//         width: 7% !important;
//     }
// }

.pc-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background: rgba(0, 0, 0, .15);
}

@media screen and (max-width: 675px) {
    .sidebar-wrapper-open {
        width: 60% !important;
    }

    .sidebar-wrapper-close {
        width: 15% !important;
    }
}

@media (min-width:676px) and (max-width: 897px) {
    .sidebar-wrapper-open {
        width: 35% !important;
    }

    .sidebar-wrapper-close {
        width: 12% !important;
    }
}

@media (min-width:898px) and (max-width:1033px) {
    .sidebar-wrapper-open {
        width: 25% !important;
    }

    .sidebar-wrapper-close {
        width: 8% !important;
    }
}



@media (min-width: 1034px) and (max-width: 1199px) {
    .sidebar-wrapper-open {
        width: 20% !important;
    }

    .sidebar-wrapper-close {
        width: 7% !important;
    }
}

@media (min-width:1200px) and (max-width: 1499px) {
    .sidebar-wrapper-open {
        width: 20% !important;
    }

    .sidebar-wrapper-close {
        width: 7% !important;
    }

}
</style>
